import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../../../Images/logo.png";
// import RobotoBold from "../../../../utils/font/Roboto-Bold-normal.js";
// import RobotoMedium from "../../../../utils/font/Roboto-Medium-normal.js";
// import RobotoRegular from "../../../../utils/font/Roboto-Regular-normal.js";
import NotoSansRegular from "../../../../utils/font/NotoSans-Regular-normal.js";
import NotoSansBold from "../../../../utils/font/NotoSans-Bold-normal.js";
import NotoSansMedium from "../../../../utils/font/NotoSans-Medium-normal.js";

// Generate PDF
export const generatePDF = ({
  invoice,
  tax,
  deviceData,
  footerData,
  orgInfo,
  invoiceNo,
}) => {
  const doc = new jsPDF();

  // utilities
  const logoWidth = 50;
  const logoHeight = 11;
  const titleFontSize = 18;
  const tableCompanyFontSize = 9;
  const tableFontSize = 10;

  // Add Fonts
  doc.addFileToVFS("Roboto-Regular.ttf", NotoSansRegular);
  doc.addFont("Roboto-Regular.ttf", "NotoSansRegular", "normal");
  doc.addFileToVFS("Roboto-Medium.ttf", NotoSansMedium);
  doc.addFont("Roboto-Medium.ttf", "NotoSansMedium", "medium");
  doc.addFileToVFS("Roboto-Bold.ttf", NotoSansBold);
  doc.addFont("Roboto-Bold.ttf", "NotoSansBold", "bold");

  // Add Logo
  doc.addImage(logo, "PNG", 10, 10, logoWidth, logoHeight); // x, y, width, height

  // Set title
  doc.setFont("NotoSansRegular", "normal");
  doc.setFontSize(titleFontSize);
  const title = invoice ? "НЭХЭМЖЛЭХ" : "ҮНИЙН САНАЛ";
  doc.text(title, 155, 18);

  // Set company information
  doc.autoTable({
    body: [
      {
        column1: `Байгууллагын нэр: ${"Нүдэн сольюшн"} ХХК`,
        column2: `Дугаар №: ${orgInfo?.number}`,
      },
      {
        column1: "Регистрийн дугаар: 6080782",
        column2: `Төлөгчийн нэр: ${orgInfo?.orgName}`,
      },
      {
        column1: "Хаяг: Экспресс тауэр, 1100тоот",
        column2: `Регистрийн дугаар:  ${orgInfo?.orgId}`,
      },
      {
        column1: "Утас: 72722072",
        column2: `Хаяг:  ${orgInfo?.orgAddress}`,
      },
      {
        column1: "Веб хаяг: www.viot.mn",
        column2: `Утас:  ${orgInfo?.orgPhone}`,
      },
    ],
    columnStyles: {
      0: {
        cellWidth: 91,
        cellPadding: {
          top: 2,
          left: 10,
          right: 2,
          bottom: 2,
        },
      },
      1: {
        cellWidth: 91,
        cellPadding: {
          top: 2,
          left: 10,
          right: 2,
          bottom: 2,
        },
      },
    },
    startY: 30,
    //   theme: "grid",
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "NotoSansRegular",
      fontSize: tableCompanyFontSize,
    },
    alternateRowStyles: { fillColor: [242, 242, 242] },
  });

  const companyTableStartY = doc.lastAutoTable.finalY + 5;

  // Bank information
  doc.autoTable({
    head: [["Банкны нэр", "Дансны дугаар"]],
    body: [["/Хас банк/ - Нүдэн Сольюшн ХХК", "5001766122"]],
    columnStyles: {
      0: { cellWidth: 91 },
      1: { cellWidth: 91 },
    },
    // startY: 75,
    startY: companyTableStartY,
    theme: "grid",
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "NotoSansRegular",
      fontSize: tableFontSize,
      lineWidth: 0.2,
      lineColor: [200, 200, 200],
      halign: "center", // Center align text horizontally
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "NotoSansRegular",
      fontSize: tableFontSize,
      halign: "center",
    },
    alternateRowStyles: { fillColor: [242, 242, 242] },
  });

  // Set product information
  // const formatCurrency = (amount) =>
  //   amount
  //     .toLocaleString("mn-MN", { style: "currency", currency: "MNT" })
  //     .replace("₮", "") + "₮";
  const formatCurrency = (amount) => {
    return (
      amount
        .toLocaleString("mn-MN", { minimumFractionDigits: 0 })
        .replace(/,/g, ",") + "₮"
    );
  };

  const tableColumn = ["№", "Нэр", "Тоо ширхэг", "Нэгж үнэ", "Нийт үнэ"];

  const tableRows = deviceData.map((item, index) => {
    const deviceName = item.name || "-";
    const quantity = item.quantity
      ? `${
          typeof item.quantity === "string"
            ? item.quantity
            : item.quantity + " ш"
        }`
      : "-";
    // const price =
    //   typeof item.quantity === "string"
    //     ? "-"
    //     : item.price
    //     ? formatCurrency(item.price)
    //     : "-";

    const price =
      typeof item.quantity === "string"
        ? item.unitPrice
          ? formatCurrency(item.unitPrice)
          : "-"
        : item.price
        ? formatCurrency(item.price)
        : "-";

    // Calculate total price for each item
    const totalPrice =
      item.price && item.quantity
        ? formatCurrency(
            item.price * (typeof item.quantity === "string" ? 1 : item.quantity)
          )
        : formatCurrency(item?.price);

    // const totalPrice =
    //   item.price && item.quantity && !isNaN(item.quantity)
    //     ? typeof item.quantity === "string"
    //       ? formatCurrency(item.price)
    //       : formatCurrency(item.price * item.quantity)
    //     : price;

    return [index + 1, deviceName, quantity, price, totalPrice];
  });

  const deviceTableStartY = doc.lastAutoTable.finalY + 5;

  // Devices list
  doc.autoTable({
    head: [tableColumn],
    // body: tableWithTotals,
    body: tableRows,
    columnStyles: {
      0: { cellWidth: 10, halign: "center" },
      1: { cellWidth: 70, halign: "left" },
      2: { cellWidth: 30, halign: "center" },
      3: { cellWidth: 36, halign: "center" },
      4: { cellWidth: 36, halign: "center" },
    },
    startY: deviceTableStartY,
    pageBreak: "auto",
    theme: "grid",
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "NotoSansRegular",
      fontSize: tableFontSize,
      lineWidth: 0.2,
      lineColor: [200, 200, 200],
      halign: "center",
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "NotoSansRegular",
      fontSize: tableFontSize,
      halign: "center",
    },
    alternateRowStyles: { fillColor: [240, 240, 240] },
  });

  // Prepare rows for totals
  const totalRow = [
    tax ? "НӨАТ-гүй дүн" : "Нийт дүн",
    formatCurrency(orgInfo?.amount),
  ];

  const tableWithTotals = [totalRow];

  // Add tax and final total if tax is applicable
  if (tax) {
    const totalNOUT = ["НӨАТ", formatCurrency(orgInfo?.tax)];
    const total = ["Нийт дүн", formatCurrency(orgInfo?.amount + orgInfo?.tax)];
    tableWithTotals.push(totalNOUT, total);
  }

  // Calculate bottom-right position dynamically
  const pageWidth = doc.internal.pageSize.width;
  const tableWidth = 102;
  const rightMargin = 14;
  const leftPosition = pageWidth - tableWidth - rightMargin;

  const totalTableStartY = doc.lastAutoTable.finalY;

  // total list
  doc.autoTable({
    // head: [tableColumn],
    body: tableWithTotals,
    columnStyles: {
      0: { halign: "center", cellWidth: 66 },
      1: { halign: "center", cellWidth: 36 },
    },
    startY: totalTableStartY,
    margin: { left: leftPosition }, // Align to bottom-right

    theme: "grid",
    bodyStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      font: "NotoSansRegular",
      fontSize: tableFontSize,
      halign: "center",
    },
    alternateRowStyles: { fillColor: [240, 240, 240] },
  });

  const nextTableStartY = doc.lastAutoTable.finalY + 10;

  // additional information
  if (footerData.length > 0 && !invoice) {
    doc.autoTable({
      head: [["Нэмэлт мэдээлэл"]],
      body: footerData.map((item) => [item]),
      columnStyles: {
        0: {
          cellWidth: 182,
          halign: "left",
          cellPadding: {
            top: 3,
            left: 10,
            right: 10,
            bottom: 3,
          },
        },
      },
      startY: nextTableStartY,
      theme: "striped",

      headStyles: {
        fillColor: [242, 242, 242],
        textColor: [0, 0, 0],
        font: "NotoSansRegular",
        fontSize: tableFontSize,
        halign: "center", // Center align text horizontally
      },
      bodyStyles: {
        fillColor: [242, 242, 242],
        textColor: [0, 0, 0],
        font: "NotoSansRegular",
        fontSize: tableFontSize,
        halign: "center",
      },
      alternateRowStyles: { fillColor: [255, 255, 255] },
    });
  }
  const imgData =
    "data:image/jpeg;base64,/9j/4QAWRXhpZgAATU0AKgAAAAgAAAAAAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAvAGMDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD7z+Mvja+bW9M8HaJNIl9eFWumt32SbWJCRh/4dxBJbsqmqEH7MdlJbqbzxDqC3ZHztaHYoJ643ZJ+pOTXjPxF1sa1feI/EDyzQDUNR/s+0vFJUW4QjkkckbEHH+0a9c+B99rq+G5PE2tahe6vq+sTfYtNtbiTbC0a/dcKB8o4ZicdB715UKka9Vwkr/5H6PWweIyvL4VsNU5OjVtZSer12stfSxj658G/CXhHU47W98Za9HeyRiSKCNtzyAkj5QBz0PHtWbceEvCFm6R/8Jn4jZbi1N6jLbuwMKk/Nn6An6DNew+LoY9EjTW/EGt6PYbCqLPcWWQpGSFUl8nkt+dcNofhHwx8S9cmvNL1nTNRuLWGON4kspojHFsKKu3zB8hGeO9XKjBO0Er/ANeZyUMzxFSn7WvUm4rdpJq//gP6mFofw/8AC2vPM2mfErUboW0L3M21mwkS4yW+bjqP1qOTwPoiLcSS+P8AXbNY4TO6yWs0ZUbdwHLfeK/MF6kc13/hTTdHl1LUNL0HUvDUt1BFJDd21vp7ZVCQHVh5nQkCsyCz8FzWN3d/2v4entrHbDczSLMViYnChiZPbbz2GOnFCoQ5VdK/q/8AMyePr+0klKdtPsxvrtf3evQ5eHwX4Zu9MW8T4o36wtIsIyXEnmEZVSu/dk9uOasQ+A9FWF54/inqaRxE+YsryAoQBlWG8EEdx1FbK+EvBaz2832vwsJ78JJbNiUGTnCNH+965zyO+Kqa54S8FSapOb/VfDcNzCTDOjXU8ZMg6+YPN5Y988mp9kl0X3s6VjJSlyqpUSf9yLf5fj+AkXgPT102bVYvifeSaZC6pJcCaUorMAQCRJxwR+dW4/B+ni8FoPiHdG780QmFppw28jITHmfeI5x6VpXWi6Fp/h0aNe3XhS20nUFS5WBZpYVnCgBXHz8j5Rz6ipoPCuk3Nzba0Ljw/K0l0pS9W8m+e4HCkHfgvj5fXHFbqnayX5s4ZYuo05SnK2tvdj8unrcmuPg7rzzRtD41v4FU52rJNg/+RKmute1P4a6xYJq9/Je6ZdMsUhlYuEyQvmqx+YYJXcpzw2QetdL4gutYvNLvtMhuBo2tmEzWd1bgSpLt5ICsPoCvXDZFfNF38Tda8dSahb+Ip4286xf7FZ2yZCzRZEodc7kLIX68dPSpq1IUHZbsMBhsRmsXKq04Q3Wl9eqster8rM+xR0orhfhX42t9e+Heg3lzcL9oa2EcnPVkJQn8duaK641IyipJ7ny9bDVKNSVKS1i2vuPmPxJ9s8P/AAz0G+s7uEwz3l1HLY3MYfzJCq7Z1U9WXnntkV9GfCfTbS30/Q4LdLlYNP0iLykvU2zK0zEuzDsTt/KvnLVIYb3wLpoubb7bf2Wo3WmtHM5WKJHUNuJ/hbK4U17l8EfEw1DQ/Dl49xJOk1odJuJZ/vpcwsWRWPfKMQD3xXj4RpVmvJH6Nn0JSy9SS2nO79W2vwvq+5h/tMRzaf4o8Da1ewPc+G7K7/01dpZEJZTuYe4B/I12niH4geDtJttS17Sr2yutWj007Xs5A25SwEavjgHewwDz1r0i6hguLeSO4jSWFhh0kUMpHuDXjWm+ONGurdzb+CLS20xrmdLvz4BGxjiQyRyhNnzBwDt969Bx9nOUr/EfK0cQsVhqVKVN/urrRpJpu9nfrutN9DzXwHa6p8H/AI4aPDrggt/7dt9k00M5eOZmz85LYwd4GR05rCtdLhvvh98Vr439zCLfU8LbQzhYZsyHG9f4vavU9W+N2iahZxahd+B/t7w2SztHMitNbsJdhiIZMjGQe2c8Ct7RfFXh3UtXg0S58G21jBqU8oMrQoYGES7gzHaBuyWGD0INeeqFN+4p3Wv4qx9ZPM8TTar1aFp2hdprX2cuba99tPyOC8caPD4o+EfgXS9JTz/E1pYrqEDwuFeCGNMuxPucAD1rV8D6f4e+Kn7O+pW7hDqapLcX1w+GmF4AW80n3wPw4robX4h+F9L8O+I/E1t4Yggg0yX+zlihREuZY8hW3KPupluPUVi2Xxg8A6HcT2Np4Re0i1ENDJ9lgjCzRqhOHUEY7jaeec9635aaleUlqrf8E4fb4utQ9lSpS5oVOdNNXT+KS9NU153ZH+zf4TtvG3w/n1HxAV1SR4X0aBJAD9ntV/gX3JbOevArI/Z98LG48aa9oN5d/bNG8K6i81nbMowZ2JQSH1wF4Hqc12Xh/wCMHhbwvp9oNL8My6dYX00K5tBGIxJIxQbsHr8hPuBmu4+HVp4duo77WdE0eDTZp7iW3nli2kzFHILblJDAnJzV06MXyWesd/M5MZmFemsXKdNxjVfurS0Wn+Ds2tO5qeMVaHS0v0IWaxmjnU5xxuAcZ9CpIr5oggb/AIX1daVpUFnqVxJezebfsmHW3dT5yEYwSoON1fSPjqYSaZDpyyKkt/OkfPaNSHkb6BFP5ivlzT9Wj8V/GxdXkvZ4bpbq4vI72NcQNbQo37pB3yB940sY9aaW9yuHIN0cTJ7cku+/S9um/wDwTG8P+JNS0nS0tIblYYopJQqAdB5jH+tFdF4R8H6j4m8P22ppa/JcNIy8dhIwH8qK8yMJ8qsz7CviMEqs1UjHmu77b31NfXvDEUfxS8VeA7+9fTdP8USx3drOqbgJA3mAde53r9cV7J4P+Cul+DY9Vs7a+vLjRr/a40+d8iCUf8tEccg9PyFVvjR8JX+ItnZXmnSx2muae26GRyQJFznYWHKnPII6GuDXVPjxpjfZxaaddRx/KrzSQs5A7k5GT74r0VGOHm3KDfZpdOx8jKtUzXCwhRxMYaLnjJqKclZKS06pL0s+565deH9Z021mlh8UXrQxIX8uS1hlcgDOASBk8d681b42WLtbb/EuoWsFzayXST3Gkwqm1M+pzklWA9SKz/8AhJvjoyss2iaRJG3BRniII7j/AFlYl5N8Spo44rjwB4Zlih2CNWjgYLsztwDJxjJx9aqWIv8AAmvVMnC5Sk2q9SnL0qQX5o66T4tackcTt4y8wzWEeoE/2REx8tnCgMA33wSCR6Cqen/HDSNYs9UeTxSfsVm8cUjXWioFl8xinyrv5HXOR0rjVuvHNvIrD4deGUkSbzwyxQDEn97/AFnsKRb/AMWR3Dzn4YeGDI5Jd9sXzE55x5vufzrJ4id1p+Ej1Vk+G5Xflv0tUpd/Tt/wx6P/AMJVpujaneWVlf2c93Hdw6dcfYdBQnfIu5ASHGV46+1WtL8fW2t6xY2Fl4j0u5u72aeOHGjsdzxna+SH4J7E9RXn1j4i8U6XCot/hvoMBGM+XIoJIJIJPm5JBJ5PrVPRfiFrPgvUpLuy+G+h6ZdOnltNbzAErxxw/sKtYhJLX8Gcjyh1FLks5W09+lq7dfnrp008z0lvHFnGs9udX0eRbS5MMkP9gy/uXjwCSA3ATI+btuHrXXeCtSu9a0d5tJewt7VJpIiv9myW4MinDkKW9e9eBQ/FBY5pJpvh/pscvnGdjFcsC7k5Jb5ucnrnrgVv6f8AtIappcPk2/hK1hiZ2kKrdfxMxZj+JJojiqad5S/BnHiMjxM42ow185Qt+DPXfEngvW9W0nUTbaxAmtXiC2W6lgPlW0BP7xY0yeSO5Pp6V4n4o+Gg+Dul65M98uonULRNP0veP30QPM7Afwj+EY67hWvJ+1NqyMobwxbohOCzXR49+BWpoHh/VfjB4y0/xBrKKujae28RhhslYcoipkkAN8zM3JwBjinUlSxHwayNcNRx2Ux/2xqNJ6u3K3K1mkra+XzfmemfDTwkvhXwHomlzxqbiC3Xzc/32yzfqxorraK9GMIxSilsfEVq061SVWT1k2/vP//Z";

  if (invoice) {
    const finalY = doc.lastAutoTable.finalY;
    const pageWidth = doc.internal.pageSize.getWidth();
    const text = "Б.Тэмүүлэн"; // Name text
    const fontSize = 11;

    // Image settings
    const imgWidth = 25; // Adjust the width of the image
    const imgHeight = 10; // Adjust the height of the image

    // Set font for the text
    doc.setFont("NotoSansRegular", "normal");
    doc.setFontSize(fontSize);

    // Calculate the width of the label text and the name text
    const labelText = "Нэхэмжлэх бэлдсэн:";
    const labelTextWidth = doc.getTextWidth(labelText);
    const nameTextWidth = doc.getTextWidth(text);

    // Total width of the label text, image, and name text
    const totalWidth = labelTextWidth + imgWidth + nameTextWidth + 4; // 4 is for some spacing between image and name

    // Calculate the starting X-position to center everything on the page
    const imgX = (pageWidth - totalWidth) / 2;

    // Add the text "Нэхэмжлэл бэлдсэн:"
    doc.text(labelText, imgX, finalY + 30); // Position text before the image

    // Add the image
    doc.addImage(
      imgData,
      "PNG",
      imgX + labelTextWidth + 2, // Image comes after the label text
      finalY + 23,
      imgWidth,
      imgHeight
    );

    // Add the name
    const textX = imgX + labelTextWidth + imgWidth + 4; // Position the name after the image
    doc.text(text, textX, finalY + 30); // Position the name text after the image
  }

  if (invoice) {
    const finalY = doc.lastAutoTable.finalY;
    const pageWidth = doc.internal.pageSize.getWidth();
    const text = "Хамтран ажилласанд баярлалаа";
    const fontSize = 11;

    doc.setFont("NotoSansRegular", "normal");
    doc.setFontSize(fontSize);
    doc.setTextColor(0, 128, 0);
    const textWidth = doc.getTextWidth(text);

    // Calculate center position
    const centerX = (pageWidth - textWidth) / 2;
    doc.text(text, centerX, finalY + 45);
  }

  // Save the PDF
  const fileName = invoice ? "Invoice" : "Quote";
  doc.save(`${fileName}-${invoiceNo || ""}.pdf`);
};
